// @flow @jsx h
import { h } from 'preact'
import { Option } from './Option'
import styles from './Options.css'

import type { Options as OptionsType } from '../../types'

type Props = {
  options: OptionsType,
  onAnswerClick: Function
}

export const Options = (props: Props) => {
  const { options, onAnswerClick } = props
  return (
    <ol class={styles.options}>
      {options.map(option => <Option key={option.response} option={option} onAnswerClick={onAnswerClick} />)}
    </ol>
  )
}



// WEBPACK FOOTER //
// ./src/v1/components/Foreground/Options.js